// Accès à la fonctionnalité « État des lieux » (rollout progressif).
//
// FAIL-CLOSED : par défaut PERSONNE n'y a accès. Seuls les e-mails de la liste blanche
// ci-dessous voient l'entrée de menu et peuvent ouvrir les écrans. Un utilisateur sans
// e-mail lisible, ou hors liste, est traité comme non autorisé (aucun accès).
//
// Ce garde-fou protège les 1 840 clients : la fonctionnalité est déployée mais reste
// invisible et inaccessible pour tout le monde sauf la liste blanche, le temps de la
// valider en conditions réelles. Élargir l'audience = ajouter des e-mails ici + redéployer.
const EDL_ALLOWLIST = ['charly.leggeri@limeare.com', 'axel@horiz.io', 'janani@horiz.io']

// E-mail de connexion (Keycloak), en minuscules. '' si non lisible -> non autorisé.
function getCurrentEmail() {
  const tp = (typeof window !== 'undefined' && window.keycloak && window.keycloak.tokenParsed) || null
  if (!tp) return ''

  return (tp.email || (tp.rl_profile && tp.rl_profile.username) || '').trim().toLowerCase()
}

export function isEdlEnabled() {
  const email = getCurrentEmail()

  return !!email && EDL_ALLOWLIST.includes(email)
}
